import { useQuery } from '@tanstack/react-query';

import { getTickets } from '../api';
import { experiencesQueryKeys } from '../data';
import { useTableFilter, useTablePagination } from '../store';

export const useGetTickets = () => {
  const filters = useTableFilter();
  const pagination = useTablePagination();

  const filesQuery = useQuery({
    queryKey: [
      ...experiencesQueryKeys.getTickets,
      {
        ...filters,
        ...pagination,
      },
    ],
    queryFn: getTickets.bind(null, { ...filters, ...pagination }),
    staleTime: 5_000,
  });

  return filesQuery;
};
